import {
  SignInDTO, SignInResponseDTO,
} from 'features/login/types';
import { signInUrl, verifyLockPassword } from 'common/utils/network/endpoints';
import { baseApi } from 'common/store/baseApi';

interface VerifyLockPasswordResponse {
  success: boolean;
  message: string;
  data: {
    unlocked: boolean;
    user: {
      id: number;
      first_name: string;
      last_name: string;
      email: string;
    };
  };
}

export const userApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['User'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      signIn: builder.mutation<SignInResponseDTO, SignInDTO>({
        query: (formData) => ({
          url: signInUrl,
          method: 'POST',
          body: formData,
        }),
      }),
      // Lock screen password verification (bypasses MFA/OTP)
      verifyLockPassword: builder.mutation<VerifyLockPasswordResponse, { password: string }>({
        query: ({ password }) => ({
          url: verifyLockPassword,
          method: 'POST',
          body: { password },
        }),
      }),
    }),
  });

export const {
  useSignInMutation,
  useVerifyLockPasswordMutation,
} = userApi;
